import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Plus, BarChart3, Target, Settings } from 'lucide-react';
import { cn } from '@/lib/utils';

const navigationItems = [
  {
    path: '/',
    icon: Home,
    label: 'Dashboard',
    testId: 'nav-dashboard'
  },
  {
    path: '/add',
    icon: Plus,
    label: 'Add Expense',
    testId: 'nav-add-expense'
  },
  {
    path: '/insights',
    icon: BarChart3,
    label: 'Insights',
    testId: 'nav-insights'
  },
  {
    path: '/challenges',
    icon: Target,
    label: 'Challenges',
    testId: 'nav-challenges'
  },
  {
    path: '/settings',
    icon: Settings,
    label: 'Settings',
    testId: 'nav-settings'
  }
];

export default function BottomNavigation() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-background border-t border-border z-50"
      data-testid="bottom-navigation"
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-around py-2">
          {navigationItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={cn(
                  "flex flex-col items-center gap-1 p-2 rounded-lg transition-colors min-w-0 flex-1",
                  isActive 
                    ? "text-primary bg-primary/10" 
                    : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
                )}
                data-testid={item.testId}
              >
                <Icon className="h-5 w-5" />
                <span className="text-xs font-medium leading-none">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}